import { localURLMaker, urlMaker } from '@shared/utils/url-maker'
import { caller } from '@shared/utils/caller'
import { ApiResponse } from '@shared/utils/api-response'
import { Product, ProductFormData, ProductFormDataApi, ProductFormErrors, ProductSelect } from '../types'
import { ProductMappers } from '../mappers'
import { appendToFormData } from '@shared/utils/apply-to-form-data'
import { NextTableMetaResponse } from '@shared/modules/next-table/types'
import { nextTableMetaMapper } from '@shared/modules/next-table/utils/meta-mapper'
import { formDataFlat } from '@shared/utils/form-data-flat'

export class ProductsService {
  public static async getAll(
    query?: Record<string, any>,
  ): Promise<ApiResponse<200, Product[], NextTableMetaResponse> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/products', query)

    try {
      const response = await caller(url)

      if (response.ok) {
        const { data, ...meta } = await response.json()
        return new ApiResponse(200, ProductMappers.manyFromApi(data), nextTableMetaMapper(meta.meta))
      } else {
        return new ApiResponse(400, 'Məlumatlar əldə edilə bilmədi', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi', null)
    }
  }

  public static async getSelect(): Promise<ApiResponse<200, ProductSelect[]> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/products/select')

    try {
      const response = await caller(url)

      if (response.ok) {
        const { data } = await response.json()
        return new ApiResponse(200, ProductMappers.manySelectFromApi(data), null)
      } else {
        return new ApiResponse(400, 'Məlumatlar əldə edilə bilmədi', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi', null)
    }
  }

  public static async getOneById(id: string | number): Promise<ApiResponse<200, Product> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/products/info', { product_id: id })

    try {
      const response = await caller(url)

      if (response.ok) {
        const { data } = await response.json()
        return new ApiResponse(200, ProductMappers.fromApi(data), null)
      } else {
        return new ApiResponse(400, 'Məlumatlar əldə edilə bilmədi.', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi.', null)
    }
  }

  public static async createOrUpdate(
    values: ProductFormData,
    type: string = 'create',
  ): Promise<ApiResponse<200> | ApiResponse<422, ProductFormErrors> | ApiResponse<400 | 500, string>> {
    const url = type === 'create' ? urlMaker('/api/products/create') : urlMaker('/api/products/edit')
    const body = new FormData()

    appendToFormData<ProductFormDataApi>(ProductMappers.formDataToApi(values), body)

    try {
      const response = await caller(url, { body, method: 'POST' })

      if (response.ok) {
        return new ApiResponse(200, null, null)
      } else if (response.status === 422) {
        const { errors } = await response.json()

        return new ApiResponse(422, ProductMappers.formErrorsFromApi(errors), null)
      } else {
        return new ApiResponse(400, 'Əməliyyat aparıla bilmədi.', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi.', null)
    }
  }

  public static async actionByIds(ids: (string | number)[], action: string): Promise<ApiResponse<200> | ApiResponse<400 | 500, string>> {
    const url = urlMaker(localURLMaker('/api/products/:action', { action }))
    const body = new FormData()

    appendToFormData(formDataFlat({ product_id: ids }), body)

    try {
      const response = await caller(url, { method: 'POST', body })

      if (response.ok) {
        return new ApiResponse(200, null, null)
      } else {
        return new ApiResponse(400, 'Əməliyyat aparıla bilmədi.', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi.', null)
    }
  }
}
